import Button from "../ui/Button";
import { arrayMap } from "./array.utils";
import { getJson } from "./json.utils";
import { convertNumberToWords, currency, formatMobileNumber } from "./number.utils";

// money receipt edit formatter
export function moneyReceiptFormatter(editItem) {
  const parseAttachement = editItem?.attachment ? JSON.parse(editItem.attachment) : null;

  const customerInfo = parseAttachement?.customer;

  const bank_will_pay = customerInfo?.bank_will_pay ? Number(customerInfo?.bank_will_pay) : 0;
  const unit_price = customerInfo?.unit_price ? Number(customerInfo?.unit_price) : 0;

  const customer_will_pay = customerInfo?.customer_will_pay
    ? Number(customerInfo?.customer_will_pay)
    : 0;

  const loanTotal = bank_will_pay + customer_will_pay;

  const loanTotalInwords = convertNumberToWords(loanTotal);

  const customer = {
    profile: {
      name: customerInfo?.name ?? "",
      mobile: customerInfo?.mobile ?? "",
      email: customerInfo?.email ?? "",
      designation: customerInfo?.designation ?? "",
      id: customerInfo?.customer_id ?? "",
      account_name: customerInfo?.account_name ?? ""
    },
    address: customerInfo?.address ?? "",
    loan: {
      bank_name: customerInfo?.bank_name ?? "",
      branch_name: customerInfo?.branch_name ?? "",
      bank_will_pay,
      customer_will_pay,
      unit_price,
      total: loanTotal,
      inwords: loanTotalInwords,
      pay_order_collector_name: parseAttachement?.customer?.pay_order_collector_name ?? "",
      po_collector: editItem?.po_collector
    },
    delivery: {
      delivery_services: parseAttachement?.customer?.delivery_services ?? "",
      delivery_papers: parseAttachement?.customer?.delivery_papers ?? "",
      expected_delivery_date: parseAttachement?.customer?.expected_delivery_date ?? ""
    }
  };

  let car = null;

  function handleCarFormat(data) {
    if (!data) return null;

    const features = data?.descriptions ? data?.descriptions?.split(",") : [];

    const price = data?.price ? Number(data.price) : 0;
    const registration_cost = data?.registration_cost ? Number(data.registration_cost) : 0;
    const discount = data?.discount ? Number(data.discount) : 0;

    const additionalCost = data?.additionalCost?.length
      ? data?.additionalCost?.reduce((prev, item) => {
          const price = item?.cost;
          return price ? prev + Number(price) : prev;
        }, 0)
      : 0;

    const total = additionalCost + price + registration_cost - discount;
    const inwords = convertNumberToWords(total);

    const result = {
      ...data,
      fullChassis: data?.chassis,
      features,
      id: data?.id ?? data?.stock_list_id,
      total,
      inwords,
      price,
      registration_cost,
      discount
    };

    return result;
  }

  if (editItem?.is_multi && parseAttachement?.car?.length) {
    car = arrayMap(parseAttachement?.car, (item) => handleCarFormat(item));
  } else {
    car = handleCarFormat(parseAttachement?.car);
  }

  const totalPayment = editItem?.payments?.reduce((a, c) => a + c.amount, 0);

  const result = editItem?.id
    ? {
        customer,
        car,
        id: editItem?.id ?? "",
        caid: editItem?.caid ?? "",
        cid: editItem?.customer?.customer_id ?? "",
        qoutDate: parseAttachement?.qoutDate ?? "",
        validUntil: parseAttachement?.validUntil ?? "",
        amount: parseAttachement?.amount,
        is_multi: editItem?.is_multi ?? "",
        type_id: editItem?.type_id ?? "",
        payments: editItem?.payments ?? "",
        totalPayment,
        old: editItem
      }
    : null;

  return result;
}

// additional cost types
const additionalCostTypes = [
  {
    label: "CNG/LPG Conversion",
    value: 1
  },
  {
    label: "Decoration",
    value: 2
  },
  {
    label: "Bumper",
    value: 3
  },
  {
    label: "Others",
    value: 4
  }
];

// get all additional cost
export function getAllAdditionalCost() {
  return additionalCostTypes;
}

// get additional cost by value
export function getAllAdditionalCostById(id) {
  return additionalCostTypes.find((item) => item.value === id) || "";
}

// view button styles
const viewButtonStyled = {
  cursor: "pointer",
  color: "var(--primary-text-color)",
  fontWeight: 500
};

// loan formatter for viewing
export function viewLoanFormatterFunc(data, { handleCollectorView = () => {} }) {
  const PoCollector = () => {
    return (
      <span
        style={viewButtonStyled}
        onClick={() => handleCollectorView(data?.po_collector?.username)}>
        {data?.po_collector?.name || "N/A"}
      </span>
    );
  };

  const formattedData = [
    {
      label: "Bank Name",
      value: data?.bank_name || "N/A"
    },
    {
      label: "Branch Name",
      value: data?.branch_name || "N/A"
    },
    {
      label: "PO Collector",
      value: PoCollector()
    },
    {
      label: "Unit Price",
      value: data?.unit_price ? currency(data?.unit_price) : "N/A"
    },
    {
      label: "Bank Paid",
      value: data?.bank_will_pay ? currency(data?.bank_will_pay) : "N/A"
    },
    {
      label: "Customer Paid",
      value: data?.customer_will_pay ? currency(data?.customer_will_pay) : "N/A"
    },
    {
      label: "Total",
      value: data?.total > 0 ? currency(data?.total) : "N/A"
    },
    {
      label: "In Words",
      value: data?.inwords && data?.total > 0 ? data?.inwords : "N/A"
    }
  ];

  return formattedData;
}

// view customer formatter function
export function viewCustomerFormatterFunc(data, { handleCustomerView = () => {} }) {
  function NameHanlder() {
    return (
      <span style={viewButtonStyled} onClick={() => handleCustomerView(data?.customer_id)}>
        {data?.name || "N/A"}
      </span>
    );
  }

  const newData = [
    {
      label: "Name",
      value: NameHanlder()
    },
    {
      label: "Mobile",
      value: data?.mobile ? formatMobileNumber(data?.mobile) : "N/A"
    },
    {
      label: "Email",
      value: data?.email || "N/A"
    },
    {
      label: "Designation",
      value: data?.designation || "N/A"
    },
    {
      label: "Account Name",
      value: data?.account_name || "N/A"
    },
    {
      label: "Address",
      value: data?.address || "N/A"
    }
  ];

  return newData;
}

// view customer agreement
export function viewCustomerAgreementFormatterFunc(data) {
  //  handle additional cost
  function handleAdditionalCost() {
    return arrayMap(data?.additionalCost, (item) => ({
      label: item?.name?.label ?? "",
      value: item?.cost ? currency(Number(item?.cost)) : "N/A"
    }));
  }

  const formattedData = [
    {
      label: "Car Price",
      value: currency(data?.price)
    },
    {
      label: "Registration Cost",
      value: currency(data?.registration_cost)
    },
    ...handleAdditionalCost(),
    {
      label: "Discount",
      value: currency(data?.discount)
    },
    {
      label: "Total",
      value: currency(data?.total)
    },
    {
      label: "Inwords",
      value: data?.inwords || "N/A"
    }
  ];

  return formattedData;
}

// view delivery formatter
export function viewDeliveryFormatterFunc(data) {
  // handle delivery items
  function DeliveryItems({ data }) {
    return (
      <div className="d-flex flex-wrap gap-2 mt-2">
        {arrayMap(data, (item, index) => (
          <Button key={index} name={item?.label ?? ""} />
        ))}
      </div>
    );
  }

  const formattedData = [
    { label: "Delivery Date", value: data?.expected_delivery_date || "N/A" },
    {
      label: `Delivery Services (${data?.delivery_services?.length || 0} Pcs)`,
      value: DeliveryItems({ data: data?.delivery_services || [] })
    },
    {
      label: `Delivery Papers (${data?.delivery_papers?.length || 0} Pcs)`,
      value: DeliveryItems({ data: data?.delivery_papers || [] })
    }
  ];

  return formattedData;
}

export function attachmentParsedForMoneyReceipt(data) {
  const attachment = getJson(data?.attachment) ?? {};

  const { customer = {}, car = {} } = attachment;

  const safe = (v) => v ?? "";

  return {
    customer: {
      profile: {
        name: customer?.account_name || customer?.name || "",
        designation: safe(customer?.designation),
        mobile: safe(data?.customer?.mobile),
        email: safe(data?.customer?.email),
        id: safe(data?.customer?.id),
      },
      address: safe(customer?.address),
      loan: {
        bank_name: customer?.account_name ? safe(customer?.name) : "",
        branch_name: customer?.account_name ? safe(customer?.designation) : "",
        bank_will_pay: "",
        customer_will_pay: "",
        unit_price: safe(car?.total),
        pay_order_collector_name: ""
      }
    },
    car: {
      id: safe(car?.stock_list_id),
      sku: safe(car?.sku),
      name: safe(car?.name),
      fullChassis: safe(car?.chassis),
      engine: safe(car?.engine),
      brta_reg: "",
      year: safe(car?.year),
      color: safe(car?.color),
      cc: safe(car?.cc),
      fuel: safe(car?.fuel),
      discount_price: "",
      price: safe(car?.price),
      registration_cost: safe(car?.registration_cost),
      discount: "",
      additionalCost: "",
      descriptions: safe(car?.descriptions)
    }
  };
}
